
import { defineComponent, computed, ref } from "vue";
import { useRoute } from "vue-router";
import { hideModal } from "@/core/helpers/dom";
import { editSite as UpdateSite } from "@/core/services/consensu/sites";

export default defineComponent({
  name: "EditStatusSiteModal",

  props: {
    site: { type: Object, required: true },
  },

  setup(props, context) {
    const route = useRoute();

    const submitButtonRef = ref<null | HTMLButtonElement>(null);
    const toggleActivationSiteModalRef = ref(null);

    const getModalLabel = computed(() => {
      return props.site.status.account == "active" ? "Desativar" : "Ativar";
    });

    const updateSite = async () => {
      const params = {
        ...props.site,
      };

      params.status = {
        account: props.site.status.account == "active" ? "inactive" : "active",
      };

      // submitButtonRef.value.disabled = true;
      submitButtonRef.value?.setAttribute("data-kt-indicator", "on");

      await UpdateSite(route.params.id, params).then((response) => {
        submitButtonRef.value?.removeAttribute("data-kt-indicator");

        context.emit("update", response.data);

        hideModal(toggleActivationSiteModalRef.value);
      });
    };

    return {
      submitButtonRef,
      toggleActivationSiteModalRef,
      getModalLabel,
      updateSite,
    };
  },

  components: {},

  methods: {},
});
